module.exports = __webpack_public_path__ + "static/media/pennant.1847196a.svg";